module.exports = __webpack_public_path__ + "static/media/Computer graphic.aefa3b95.png";